var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GroupsPupils',{attrs:{"items":_vm.groups},model:{value:(_vm.group_id),callback:function ($$v) {_vm.group_id=$$v},expression:"group_id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }